import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '~/components/section-title';
import { StepScroll } from '~/components/step-scroll';
import { UserCard } from '~/components/user-card';
import { ModuleType } from '~/utils/module-type';
import { User } from 'shared/models/legacy';
import { useViewTracking } from '~/utils/use-view-tracking';
import { $CurrentUserRelatedUser } from '@user/shared/atoms/current-user-related-user';

export default function UserRelatedSection(): JSX.Element | null {
  const { t } = useTranslation();
  const users = useAtomValue($CurrentUserRelatedUser);

  const observedRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: ModuleType.related_user,
      });
    }, []),
  });

  if (!users.length) {
    return null;
  }

  return (
    <section id="related-user" ref={observedRef}>
      <SectionTitle title={t('wap_seo_recommend_user')} />
      <StepScroll>
        {users.map((user: User) => (
          <UserCard user={user} key={user.userId} />
        ))}
      </StepScroll>
    </section>
  );
}
